import { Box } from '@mui/material'
import { useNavigationRailPortalContext } from './NavigationRailPortalProvider'

export default function NavigationRailPortal() {
  const { setPortalNode } = useNavigationRailPortalContext()
  return (
    <Box
      ref={setPortalNode}
      data-portal-id="navigation-rail"
      sx={{ position: 'relative' }}
    />
  )
}
